module.exports = __webpack_public_path__ + "img/network2.d671f45b.png";